module.exports = __webpack_public_path__ + "img/md-pricetags.ae695e87.svg";